// Lo que esta pantalla dice sobre el universo de su tabla y no sale del patrón compartido.
//
// Los rótulos de lo cargado viven en `@/shared/patterns/LoadedScope`: dependen de cuántas páginas
// faltan y se caen cuando no falta ninguna. El de aquí no se cae nunca.

/** A quién lista la tabla: el padrón entero, también quien solo abrió su cuenta y no ha comprado. */
export const ROSTER_SCOPE_NOTE =
    'Están todos los clientes dados de alta en el padrón, también quienes solo abrieron su cuenta PCF y no han comprado.';
